import store from './s';

export const checkDefaultShipping = () => {
    if (store.checkout != undefined && store.checkout.ship != undefined && (store.checkout.ship.shipMethod == undefined || store.checkout.ship.shipMethod.key < 0) && store.checkout.ship.shipOptions != undefined && store.checkout.ship.shipOptions.length > 0) {
        if (store.checkout.ship.shipOptions.length > 1) {
            if (store.checkout.ship.shipOptions[0].isSuperSaver) {
                store.checkout.ship.shipMethod = JSON.parse(JSON.stringify(store.checkout.ship.shipOptions[1]));
            } else {
                store.checkout.ship.shipMethod = JSON.parse(JSON.stringify(store.checkout.ship.shipOptions[0]));
            }
        } else {
            store.checkout.ship.shipMethod = JSON.parse(JSON.stringify(store.checkout.ship.shipOptions[0]));
        }

        //        console.log('def', store.checkout.ship.shipMethod);

        store.checkout.cart.pricing.shipping = store.checkout.ship.shipMethod.price_shipping;
        store.checkout.cart.pricing.production = store.checkout.ship.shipMethod.price_production;
    }
};
